import React, { useEffect, useState, useRef, useMemo } from "react"
import { Carousel } from 'antd';
import { useShadow } from './../components/shadow'
import LazyLoad from 'react-lazyload';
import { PortfolioImg } from '../components/showbigimg'
import { useModal } from '../components/usemodal'

export function TeachingGroupPh(props) {
  let { change, setChange, atlist, atcolist } = props
  useEffect(() => {
    window.addEventListener('scroll', function (e) {
      document.documentElement.style.overflow = 'hidden'
    })
  }, [])

  return (
    <div className="assist-ph-group-box">
      <div className="assist-ph-box">
        <MainTeacherPh />
      </div>
      <div className="asssist-ph-secaond-part"><MoreWorkPh change={change} setChange={setChange} /></div>
      <AssistantGroupPh atlist={atlist} {...props} />
      <CollectionPortfolio atcolist={atcolist} />
    </div>
  )
}

// export  function PortfolioImg(props){
//   let {index,atcolist} =props
//   const [page,setPage] = useState(atcolist.findIndex(i=>i.id===index))
//   const imgref=useRef()

//   useEffect(()=>{
//     imgref.current.goTo(page,true)
//   },[index])
//   return(
//     <div className="portfolioart">
//       <div className="portfolioart-img">
//         <Carousel dots={false} ref={imgref} beforeChange={(_,next)=>{
//           setPage(next+1)
//         }} >
//           {
//             atcolist?atcolist.map((i)=>{
//               return(
//                 <div className="big-img-box">
//                   <img alt="jiazaiz" src={i.url} width="100%" height="100%" style={{objectFit:"contain"}}/>
//                 </div>
//               )
//             }):''
//           }
//         </Carousel>
//       </div>
//       <div className="portfolioart-page">{page}/{atcolist.length}</div>
//     </div>
//   )
// }

function CollectionPortfolio(props) {
  let { atcolist } = props
  const [index, setIndex] = useState()
  const { show, hide, RenderModal } = useModal()
  const [data, setData] = useState(atcolist)
  useEffect(() => {
    let arr = atcolist.reduce((prev, next) => {
      prev.push(next.url)
      return prev
    }, [])
    setData(arr)
  }, [atcolist])



  return (
    <div className="collectionportfolio">
      <div className="collectionportfolio-title">
        <div>助教作品</div>
        <div>ASSISTANT ARTWORKS</div>
      </div>
      <div className="lazyloadcollection">
        {
          atcolist ? atcolist.map((i) => {
            return (
              <LazyLoad scrollContainer={'.home-content'} offset={0} key={i.smallPicture} height={200} resize={true}  >
                <img alt="jiazaiz" src={i.smallPicture} width="100%" height="100%" style={{ objectFit: 'cover' }} onClick={() => {
                  show()
                  setIndex(i.url)
                }} />
              </LazyLoad>
            )
          }) : ''
        }
      </div>
      <div style={{ paddingBottom: "0.5rem", textAlign: 'center', color: "#ad9d8f" }}>没有更多了</div>
      {show && <RenderModal><PortfolioImg change={data} hide={hide} index={data.findIndex(i => i === index)} /></RenderModal>}
    </div>
  )
}

function AssistantGroupPh(props) {
  let { atlist } = props
  const [showmore, setShowMore] = useState(0)
  useEffect(() => {
    let domheight = document.querySelector('.assistantgroupph-avator-box')
    if (!domheight) return
    let heightbox = window.getComputedStyle(domheight, null).height.replace('px', '') * 1
    if (heightbox <= 3 + 'rem' || isNaN(heightbox)) {
      setShowMore(0)
    }
    else {
      setShowMore(2)
    }

  }, [atlist])
  return (
    <div className="assistantgroupph">
      <div className="assistantgroupph-title">
        <div>助教团队</div>
        <div>ASSISTANT TEAM</div>
      </div>
      <div className="assistantgroupph-avator-box" style={{ height: showmore === 1 ? 'auto' : showmore === 2 ? '3rem' : '', overflow: "hidden" }}>
        {
          atlist ? atlist.map(i => {
            return (
              <div key={i.id} className="assistantavator" onClick={() => { props.history.push(`/teache/${i.id}`, { i, atlist }) }}>{i.avatar ? <img alt="jiazaiz" src={i.avatar} width="100%" height="100%" /> : <div style={{ width: '100%', height: '100%', backgroundColor: "#efebe9" }}></div>}</div>
            )
          }) : ''
        }
      </div>
      {showmore === 2 ? <div className="clicklookmoreph" onClick={() => setShowMore(1)}>
        <div>MORE</div>
        <div></div>
      </div> : showmore === 1 ? <div className="clickupbtnph" onClick={() => setShowMore(2)}><div>CLOSE</div><div></div></div> : null}
    </div>
  )
}

function MainTeacherPh(props) {
  return (
    <div className="mainteacher-bg">
      <div className="down-text">
        <div className="mainteacher-logo"></div>
        <div className="ph-social-media">
          <div className="social-media-text">
            <div className="en-social-media-text"><span>KRENZ'S SOCIAL MEDIA</span></div>
            <div className="cn-social-media-text"><span>KRENZ的社交媒体</span></div>
          </div>
          <div className="ph-social-icon">
            <a href="https://www.cctalk.com/m/group/82776894" rel="noreferrer" target="_blank"><div className="ph-cc"></div></a>
            <a href="https://space.bilibili.com/181578039" rel="noreferrer" target="_blank"><div className="ph-bili"></div></a>
            <a href="https://www.weibo.com/u/1926245291" rel="noreferrer" target="_blank"><div className="ph-weibo"></div></a>
            <a href="https://www.zhihu.com/org/kkmo-fa-xue-yuan" rel="noreferrer" target="_blank"><div className="ph-zhihu"></div></a>
            {/* <a href='https://www.artstation.com/krenz' rel="noreferrer" target="_blank"><div className="ph-art"></div></a> */}

          </div>
        </div>
        <div className="ph-text-intro">
          <div className="ph-intro-text">
            <div><span>1985年生，台湾桃园人，元智大学信息传播学系毕业，现为Krenz's Artwork创办人及主讲师，目前在亚洲具有相当知名度。</span></div>
            <div><span>老师从2009年开始，研究动漫美术相关的2D绘图创作技巧，并陆续开设透视、动态、色彩等以美术基础为主的课程。因擅长解析，且用语、示范浅显易懂，逐渐在绘图教学界造成话题。</span></div>
            <div><span>2018年组织教学团队，展开网络课程，意透过教学将计算机绘图的技巧与观念交流传承给更多人，矢志带动绘图界人才的增长与水平。</span></div>
            <div><span>近12年的自由绘画经验，8年实体班教授CG绘画经验，不仅让老师在ARTSTATION影响力挤身 TOP 10，更于2015年取得了全站获赞数第一的成就。个人画册累计销售十数万册，且数次成为Schoolism、Animuc、The One Academy、厦门国际动漫节等海内外著名CG盛会的座上宾。</span></div>
          </div>
        </div>

      </div>
    </div>
  )
}

function MoreWorkPh(props) {

  let { change } = props
  const [imgindex2, setImgIndex2] = useState(0)
  const [index, setIndex] = useState(undefined)
  const imgbox = useRef()
  const next = () => {
    imgbox && imgbox.current.next()
  }

  useEffect(() => {
    let timer = setInterval(() => {
      imgbox.current.next()
    }, 2000)
    return () => {
      clearInterval(timer)
    }
  }, [])

  const prev = () => {
    imgbox && imgbox.current.prev()
  }

  let setShadow = useShadow(useMemo(() => <RenderBigImgPh change={change} index={index} />, [index, change]))

  return (
    <div className="more-work-ph-box">
      <div className="more-work-ph-box-entext"><span>MORE WORKS</span></div>
      <div className="more-work-ph-cn">更多作品</div>
      <div className="ph-slide-box">
        <div className="left-arrow-ph" onClick={(e) => { prev() }}></div>
        <div className="right-arrow-ph" onClick={(e) => { next() }}></div>
        <div className="make-center" onClick={e => {
          if (e.target.tagName !== 'IMG') {
            return
          }
          else {
            setShadow(true)
            setIndex(change.findIndex(j => e.target.src.match(j.url) !== null))
          }
        }}>
          <Carousel autoplay={false} dots={false} ref={imgbox} beforeChange={(_, next) => {
            setImgIndex2(next)
          }} lazyLoad="progressive">
            {change && change.length > 0 ? change.map(i => {
              return (
                <div key={i.url}>
                  <div className="showimg-ph">
                    <img alt="jiazaiz" src={i.url} />

                    <div className="explain-text">
                      {i.description}
                    </div>
                  </div>
                </div>)
            }) : null}
          </Carousel>
          {change && change.length > 0 ? <div className="page-style">{imgindex2 + 1}/{change.length}</div> : null}
        </div>
      </div>
    </div>
  )
}

class RenderBigImgPh extends React.Component {

  state = {
    page: this.props.index + 1,
    page2: this.props.index + 1
  }

  componentDidMount() {
    this.ImagBox.goTo(this.props.index, true)
  }

  settings = {
    speed: 300
  }

  render() {
    return (
      <div className="big-img-box-ph">
        <div className="make-flex">
          <div>
            <Carousel beforeChange={(_, next) => {
              this.setState({
                page2: next
              })
            }} slickGoTo={this.state.page} ref={id => this.ImagBox = id} dots={false} afterChange={(index) => {
              this.setState({
                page: index + 1
              })
            }}  {...this.settings} >
              {this.props.change.map(i => {
                return <div key={i.url} >
                  <div className="description-ph"><span >{i.description}</span></div>
                  <div className="intolittle-ph"> <img alt="jiazaiz" src={i.url} /></div>
                </div>
              })}
            </Carousel>
            <div className="page-style">{this.state.page2 + 1}/{this.props.change.length}</div>
          </div>
        </div>
      </div>
    )
  }
}

